// Currency display formatters. Single source of truth so every
// surface (header, shop entries, NPC reward pills, post-match toast)
// renders mL / L the same way.
//
// Convention (per product):
//   - amounts ≤ 1000 mL render as "X mL"
//   - amounts > 1000 mL render as "X.X L" (no trailing zero when whole)
//
// Gold is plain integer with thousands separators.

export function formatVoidJuice(mL: number): string {
  if (mL <= 1000) return `${mL} mL`;
  const liters = mL / 1000;
  const hasFraction = mL % 1000 !== 0;
  return `${liters.toFixed(hasFraction ? 1 : 0)} L`;
}

export function formatGold(coins: number): string {
  return coins.toLocaleString();
}
